import React, { useEffect, useState, useRef } from "react";
import SearchComponent from "../../Search/SearchComponent/SearchComponent";
import "./dirpersonal.css";
// import { Personal } from "../../../json/Prueba";
const res = await fetch('/JSON/directorio/directorioSSH.json')
const Directorio = await res.json()


const DirPersonalSSH = () => {
  const [search, setSearch] = useState("");
  const searchInput = useRef();
  const personal = Directorio.persona;
  // personal = JSON.stringify(Personal);
  // personal = JSON.parse(personal);

  const searchTram = () => {
    // personal = JSON.stringify(Personal);
    // personal = JSON.parse(personal);
    setSearch(searchInput.current.value);
  };

  let filterPersonal = personal.filter((persona) => {
    if(persona.nombre.toLowerCase().includes(search.toLowerCase())
    // if(persona.cargo.toLowerCase().includes(search.toLowerCase())  
      || persona.cargo.toLowerCase().includes(search.toLowerCase())
      // || persona.sexo.toLowerCase().includes(search.toLowerCase())
      || persona.domicilio.toLowerCase().includes(search.toLowerCase())
      || persona.telefono.toLowerCase().includes(search.toLowerCase())
      || persona.correo.toLowerCase().includes(search.toLowerCase())
    ){
      return persona;
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Directorio de Personal SSH</h1>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <span className="textoencabezado">Ejercicio: </span><span className="texto">{Directorio.datos_generales.Ejercicio}</span>
        </div>
        <div className="col-6">
          <span className="textoencabezado">Fecha de última actualización: </span><span className="texto">{Directorio.datos_generales.Fecha_de_actualizacion}</span>
        </div>
        {/* <div className="col-4">
            Val3
        </div> */}
      </div>
      {/* <div className="row">
        <div className="col-6">
          <span className="textoencabezado">Fecha de inicio del periodo que se informa: </span><span className="texto">01/10/2024</span>
        </div>
        <div className="col-6">
          <span className="textoencabezado">Fecha de término del periodo que se informa: </span><span className="texto">31/12/2024</span>
        </div>
      </div> */}
      {/* <div className="row">
        <div className="col-12">
          <span className="textoencabezado">Fecha de actualización: </span><span className="texto">10/01/2025</span>
        </div>
      </div> */}
      <div className="row">
        <div className="col-12">
          <br></br>
        </div>
      </div>
      <SearchComponent
        searchInput={searchInput}
        search={search}
        searchTram={searchTram}
      />
       <div className="row">
       <div className="table-responsive">
       <table className="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Nivel</th>
              <th>Cargo</th>
              <th>Nombre</th>
              {/* <th>Sexo</th> */}
              <th>Adscripción</th>
              {/* <th>Fecha de alta en el cargo</th> */}
              <th>Domicilio</th>
              <th>Teléfono</th>
              <th>Correo</th>
              {/* <th>Área responsable</th>
              <th>Nota</th> */}
            </tr>
          </thead>
          <tbody>
            {filterPersonal.map((item, index) => (
             <tr key={index}> 
                <td>{item.nivel}</td>
                <td>{item.cargo}</td>
                <td>{item.nombre}</td>
                {/* <td>{item.sexo}</td> */}
                <td>{item.adscripcion}</td>
                {/* <td>{item.fecha_alta_cargo}</td> */}
                <td>{item.domicilio}</td>
                <td>{item.telefono}</td>
                <td>{item.correo}</td>
                {/* <td>{item.area_responsable}</td>
                <td><div className="tdnota">{item.nota}</div></td> */}
            {/* <div className="col-12 item licitacion">
              <h1 className="numero-licitacion">{item.id_licitacion} <span className="tipo-licitacion">{item.tipo_licictacion}</span></h1>
              <div className="item cuerpo-licitacion">
              <p className="descripcion-licitacion">{item.nombre_licitacion} </p>
                
              </div>
            </div> */}
              </tr>
            ))}
          </tbody>
      </table> 
      </div> 
      </div>
    </div>
  );
};

export default DirPersonalSSH;
